"use client";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import PastWeekSignupsCard from "@/app/admin/home/_cmp/PastWeekSignupsCard";
import ChannelSignups from "@/app/admin/home/_cmp/ChannelSignups";
import GuestService from "@/app/_services/GuestService";

export default function WaitlistAnalytics() {
  const [isLoading, setLoading] = useState(true);
  const [guests, setGuests] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    GuestService.getGuests({ since: dayjs().subtract(7, "days").format("YYYY-MM-DD") })
      .then((res) => {
        if (!cancelled) setGuests(res);
      })
      .catch(() => {
        if (!cancelled) setGuests({});
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="hidden grid-cols-1 gap-2.5 md:grid md:grid-cols-2">
      <div className="flex" style={{ height: 170 }}>
        <ChannelSignups isLoading={isLoading} guests={guests} height={170} hideSubtitle compact />
      </div>
      <div className="flex" style={{ height: 170 }}>
        <PastWeekSignupsCard isLoading={isLoading} guests={guests} hideSubtitle compact />
      </div>
    </div>
  );
}
